import type { CancelScheduledOrderRequest } from '../requests';

export const SCHEDULE_ORDER_API_PATH = Object.freeze({
  list: '/api/rs-aliados-gateway/orders/partner/status/open-soon/store-orders',
  orderDetail:
    '/api/rs-aliados-gateway/orders/partner/status/orders/open-soon/:orderId',
  cancel:
    '/api/rs-aliados-gateway/orders/partner/status/proxy/cbpr/:orderId/:partnerId',
});

export const CANCEL_SCHEDULED_ORDER_PAYLOAD: CancelScheduledOrderRequest = {
  order_refuse_reason_id: 1,
  refuse_reason_enum: 'ran_out_products',
  refuse_reason_comment: 'cancel_order',
};
